<template>
    <v-container fluid>
        <v-row v-if="showPdfPreview">
            <div
                style="
                    display: show;
                    z-index: 9999999;
                    position: fixed;
                    top: 0px;
                    left: 0px;
                    background-color: rgba(255, 255, 255, 0.074);
                    width: 100%;
                    height: 100vw;
                "
            >
                <div style="margin-top: 20px; margin-bottom: 40px; width: 40%; height: 100vh; margin: 0 auto">
                    <v-btn
                        style="float: right; margin-top: 50px; margin-bottom: 10px"
                        depressed
                        @click="closePDFpreview()"
                        icon
                    >
                        <v-icon large>fas fa-window-close</v-icon>
                    </v-btn>
                    <iframe
                        id="pdf-preview-div"
                        style="width: 100%; margin-bottom: 20px; height: 87vh; display: block"
                        :src="pdfLink"
                    >
                        <p>Your browser does not support iframes.</p>
                    </iframe>
                </div>
            </div>
        </v-row>
        <v-dialog v-model="payslipModal.visible" max-width="600">
            <v-card>
                <v-card-title>{{ $t('labels.issuePayslips') }}</v-card-title>
                <v-card-text class="grey--text text--darken-2">
                    <v-row>
                        <v-col cols="7">
                            <div class="seafarer-all-block">
                                <span @click="payslipModal.selectAll()" class="float-right seafarer-all-button"
                                    ><v-icon small>fa-check-square</v-icon></span
                                >
                            </div>
                            <div class="seafarer-blocks-holder">
                                <div
                                    @click="payslipModal.toggleSeafarer(seafarer.id)"
                                    v-for="(seafarer, key) in payslipModal.data.seafarers"
                                    :key="key"
                                    class="seafarer-block"
                                >
                                    {{ seafarer.name }} {{ seafarer.surname }}
                                    <span
                                        class="float-right"
                                        v-if="payslipModal.data.selected_seafarers.includes(seafarer.id)"
                                        ><v-icon small>fa-check-square</v-icon></span
                                    >
                                    <span
                                        class="float-right"
                                        v-if="!payslipModal.data.selected_seafarers.includes(seafarer.id)"
                                        ><v-icon small>fa-square</v-icon></span
                                    >
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="5">
                            <v-row>
                                <v-col cols="12">
                                    <Dropdown
                                        v-model="payslipModal.data.billing_list_id"
                                        :ajax="true"
                                        :data="'billing-lists-for-payslips'"
                                        :errorBorder="!payslipModal.validation.billing_list_id"
                                        :label="$t('fields.billingList')"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="12">
                                    <DatePicker
                                        v-model="payslipModal.data.date_from"
                                        :errorBorder="!payslipModal.validation.date_from"
                                        :dateLabel="$t('fields.from')"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12">
                                    <DatePicker
                                        v-model="payslipModal.data.date_to"
                                        :errorBorder="!payslipModal.validation.date_to"
                                        :dateLabel="$t('fields.to')"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown
                                        v-model="payslipModal.data.internal_office_id"
                                        :ajax="true"
                                        :data="'internal-offices'"
                                        :errorBorder="!payslipModal.validation.internal_office_id"
                                        :label="$t('fields.office')"
                                    ></Dropdown>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="payslipModal.hide()">{{ $t('buttons.cancel') }}</v-btn>
                    <v-btn color="primary" :loading="issuingPayslip" @click="payslipModal.issuePayslips(true)">{{
                        $t('buttons.preview')
                    }}</v-btn>
                    <v-btn color="success" :loading="issuingPayslip" @click="payslipModal.issuePayslips()"
                        >{{ $t('buttons.issuePayslips') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col v-if="$myStore.state.user.user_role_id == 1">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
            <v-col class="text-right" v-if="$myStore.state.user.user_role_id == 1">
                <v-btn color="primary" @click="payslipBreakdownExport">
                    <v-icon small>fas fa-file-excel</v-icon>&nbsp;&nbsp;{{ $t('buttons.payslipBreakdownExport') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="payslipsTable.additionalFilters"
                                    :default-sort="payslipsTable.defaultSort"
                                    :excel="true"
                                    :fields="payslipsTable.headers"
                                    :header-selection-key="'payslips-headers'"
                                    :height="payslipsTable.height"
                                    :total-records="payslipsTable.total"
                                    :filter-save-key="'payslips-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr v-for="(item, key) in payslipsTable.items" :key="key">
                                        <td v-if="payslipsTable.selectedHeaders.includes('id')">
                                            {{ item.formatted_id }}
                                        </td>
                                        <td>
                                            <v-btn
                                                v-if="item.paid"
                                                x-small
                                                color="#00800040"
                                                fab
                                                depressed
                                                @click="togglePaid(key)"
                                            >
                                                <v-icon x-small color="#008000">fas fa-check</v-icon></v-btn
                                            >
                                            <v-btn
                                                v-if="!item.paid"
                                                x-small
                                                color="#6F6F6F40"
                                                fab
                                                depressed
                                                @click="togglePaid(key)"
                                            >
                                                <v-icon x-small color="#6F6F6F">fas fa-question</v-icon></v-btn
                                            >
                                        </td>
                                        <td v-if="payslipsTable.selectedHeaders.includes('office')">
                                            {{ item.internal_office_display }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="payslipsTable.selectedHeaders.includes('seafarer')"
                                        >
                                            {{ item.seafarer_display }}
                                        </td>
                                        <td v-if="payslipsTable.selectedHeaders.includes('rank')">
                                            {{ item.rank_display }}
                                        </td>
                                        <td v-if="payslipsTable.selectedHeaders.includes('date_of_issue')">
                                            {{ item.date_of_issue_display }}
                                        </td>
                                        <td
                                            v-if="payslipsTable.selectedHeaders.includes('earnings')"
                                            class="text-right pr-10 font-weight-bold"
                                        >
                                            {{ item.earnings_display }}
                                        </td>
                                        <td
                                            v-if="payslipsTable.selectedHeaders.includes('currency')"
                                            class="text-left font-weight-bold"
                                        >
                                            {{ item.currency_display }}
                                        </td>
                                        <td v-if="payslipsTable.selectedHeaders.includes('billing_list')">
                                            {{ item.billing_list_display }}
                                        </td>
                                        <td v-if="payslipsTable.selectedHeaders.includes('entity')">
                                            {{ item.entity_display }}
                                        </td>

                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="
                                                            getPDF(
                                                                item.id,
                                                                item.gdpr_edit_lock,
                                                                item.gdpr_payslip_file_id
                                                                    ? item.gdpr_payslip_file_id.link
                                                                    : null,
                                                            )
                                                        "
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-file-pdf</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.pdf') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn icon v-bind="attrs" @click="sendPdf(key)" v-on="on">
                                                        <v-icon small>fas fa-envelope</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.sendDocument') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="$myStore.state.user.user_role_id == 1">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn icon v-bind="attrs" @click="deleteClick(key)" v-on="on">
                                                        <v-icon small>fa-trash</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.delete') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';
import Dropdown from './trinkets/Dropdown.vue';
import DatePicker from './trinkets/DatePicker';

export default {
    name: 'Payslips',
    components: {Dropdown, TheTable, DatePicker},
    data: function () {
        return {
            payslipModal: {
                visible: false,

                data: {
                    billing_list_id: null,
                    date_from: null,
                    date_to: null,
                    internal_office_id: null,
                    seafarers: [],
                    selected_seafarers: [],
                },
                validation: {
                    billing_list_id: true,
                    date_from: true,
                    date_to: true,
                    internal_office_id: true,
                },
                show: () => {
                    this.payslipModal.visible = true;
                },
                hide: () => {
                    this.payslipModal.visible = false;
                },
                reset: () => {
                    this.payslipModal.data.billing_list_id = null;
                    this.payslipModal.data.date_from = null;
                    this.payslipModal.data.date_to = null;
                    this.payslipModal.data.internal_office_id = null;
                    this.payslipModal.data.seafarers = [];
                    this.payslipModal.data.selected_seafarers = [];

                    this.payslipModal.validation.billing_list_id = true;
                    this.payslipModal.validation.date_from = true;
                    this.payslipModal.validation.date_to = true;
                    this.payslipModal.validation.internal_office_id = true;
                },
                toggleSeafarer: (id) => {
                    let index = this.payslipModal.data.selected_seafarers.indexOf(id);
                    if (index !== -1) {
                        this.payslipModal.data.selected_seafarers.splice(index, 1);
                    } else {
                        this.payslipModal.data.selected_seafarers.push(id);
                    }
                },
                selectAll: () => {
                    let allSelected = true;
                    let everyone = [];
                    for (let seafarer of this.payslipModal.data.seafarers) {
                        if (!this.payslipModal.data.selected_seafarers.includes(seafarer.id)) {
                            allSelected = false;
                        }
                        everyone.push(seafarer.id);
                    }
                    this.payslipModal.data.selected_seafarers = allSelected ? [] : everyone;
                },
                issuePayslips: (preview = false) => {
                    let success = true;
                    let message = '';

                    if (this.payslipModal.data.billing_list_id == null) {
                        success = false;
                        this.payslipModal.validation.billing_list_id = false;
                    } else {
                        this.payslipModal.validation.billing_list_id = true;
                    }

                    if (this.payslipModal.data.internal_office_id == null) {
                        success = false;
                        this.payslipModal.validation.internal_office_id = false;
                    } else {
                        this.payslipModal.validation.internal_office_id = true;
                    }

                    if (this.payslipModal.data.date_from == null) {
                        success = false;
                        this.payslipModal.validation.date_from = false;
                    } else {
                        this.payslipModal.validation.date_from = true;
                    }

                    if (this.payslipModal.data.date_to == null) {
                        success = false;
                        this.payslipModal.validation.date_to = false;
                    } else {
                        this.payslipModal.validation.date_to = true;
                    }

                    if (this.payslipModal.data.selected_seafarers.length === 0) {
                        success = false;
                        message = this.$t('alerts.noSeafarersSelected');
                    }

                    if (success) {
                        this.issuingPayslip = true;
                        if (!preview) {
                            let vm = this;
                            this.$APICall('post', 'payslips', this.payslipModal.data, (data, success) => {
                                if (success) {
                                    if (vm.handlePayslipCurrencyMismatch(data)) {
                                        vm.issuingPayslip = false;
                                        return;
                                    }
                                    vm.payslipModal.hide();
                                    vm.payslipModal.reset();
                                    window.open(data.link);
                                    vm.reloadData(vm.payslipsTable.lastRequest);
                                    vm.$notify(vm.$t('alerts.payslipIssued'));
                                }
                                vm.issuingPayslip = false;
                            });
                        } else {
                            let vm = this;
                            this.$APICall('post', 'payslips/pdf/preview', this.payslipModal.data, (data, success) => {
                                if (success) {
                                    if (vm.handlePayslipCurrencyMismatch(data)) {
                                        vm.issuingPayslip = false;
                                        return;
                                    }
                                    window.open(data.link);
                                } else {
                                    vm.$alert(vm.$t('alerts.basicError'));
                                }
                                vm.issuingPayslip = false;
                            });
                        }
                    } else {
                        if (message !== '') {
                            this.$alert(message);
                        }
                    }
                },
            },
            payslipsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: '', allowFilter: true},
                    {text: this.$t('fields.paid'), value: 'paid', type: '', allowFilter: false},
                    {
                        text: this.$t('fields.office'),
                        value: 'office',
                        type: 'multiple|internal-offices',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.seafarer'),
                        value: 'seafarer',
                        type: 'multiple|seafarers-all',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.rank'), value: 'rank', type: '', allowFilter: true},
                    {text: this.$t('fields.dateOfIssue'), value: 'date_of_issue', type: '', allowFilter: true},
                    {
                        text: this.$t('fields.earnings'),
                        value: 'earnings',
                        type: '',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.currency'),
                        value: 'currency',
                        type: 'multiple|currencies',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.billingList'),
                        value: 'billing_list',
                        type: 'multiple|billing-lists',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.entity'), value: 'entity', type: 'multiple|entities', allowFilter: true},

                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [
                    {text: this.$t('fields.id'), value: 'formatted_id', type: 'string'},
                    {text: this.$t('fields.seafarer'), value: 'seafarer_id', type: 'dropdown|seafarers-all'},
                    {text: this.$t('fields.dateOfIssue'), value: 'date_of_issue', type: 'date_range'},
                    {text: this.$t('fields.earnings'), value: 'earnings', type: 'price_range'},
                    {text: this.$t('fields.currency'), value: 'currency_id', type: 'dropdown|currencies'},
                    {text: this.$t('fields.office'), value: 'internal_office_id', type: 'dropdown|internal-offices'},
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
            showPdfPreview: false,
            pdfSource: '',
            issuingPayslip: false,
        };
    },
    watch: {
        'payslipModal.data.billing_list_id': {
            handler: function () {
                if (this.payslipModal.data.billing_list_id === null) return;
                let vm = this;
                vm.billingListLoaded = true;
                vm.payslipModal.data.seafarers = [];
                vm.payslipModal.data.selected_seafarers = [];
                this.$APICall(
                    'get',
                    'billing-list/' + this.payslipModal.data.billing_list_id + '/payslip-data',
                    {},
                    (data, success) => {
                        if (success) {
                            for (let seafarer of data.seafarers) {
                                vm.payslipModal.data.selected_seafarers.push(seafarer.id);
                            }
                            vm.payslipModal.data.seafarers = data.seafarers;
                            vm.payslipModal.data.date_from = data.date_from;
                            vm.payslipModal.data.date_to = data.date_to;
                        }
                    },
                );
            },
            deep: true,
        },
    },
    methods: {
        /**
         * Returns true (and shows an alert) when the payslip response was blocked because a
         * seafarer's currency does not match the wage template currency; otherwise false.
         */
        handlePayslipCurrencyMismatch(data) {
            if (!data || data.success !== false || data.alert_key !== 'payslipCurrencyMismatch') {
                return false;
            }
            const message = (data.mismatches || [])
                .map((m) =>
                    this.$t('alerts.payslipCurrencyMismatch')
                        .split('%seafarer%')
                        .join(m.seafarer)
                        .split('%seafarerCurrency%')
                        .join(m.seafarer_currency)
                        .split('%wageCurrency%')
                        .join(m.wage_template_currency),
                )
                .join('<br/><br/>');
            this.$alert(message);
            return true;
        },

        payslipBreakdownExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.payslipsTable.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'payslips',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/payslips-breakdown', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        sendPdf(itemIdx) {
            let payslip = this.payslipsTable.items[itemIdx];
            this.payslipsTable.items[itemIdx].paid = !payslip.paid;
            this.$verify(this.$t('alerts.sendPayslipEmail'), (result) => {
                if (result) {
                    this.$APICall('post', 'payslips-send-email/' + payslip.id, {}, (data, success) => {
                        if (success) {
                            this.$alert(this.$t('alerts.pdfSentToSeafarer'));
                        } else {
                            this.$alert(this.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },
        closePDFpreview() {
            this.showPdfPreview = false;
            this.pdfLink = '';
        },
        getPDF(id, gdpr_edit_lock, link) {
            let vm = this;
            if (gdpr_edit_lock) {
                if (link) {
                    vm.showPdfPreview = true;
                    vm.pdfLink = link;
                } else {
                    vm.$alert(vm.$t('alerts.payslipFileLinkNotFound'));
                }
            } else {
                this.$APICall(
                    'get',
                    'payslips/pdf/' + id,
                    {},
                    (data, success) => {
                        if (success) {
                            vm.showPdfPreview = true;
                            vm.pdfLink = data.link;
                            // window.open(data.link);
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    },
                    true,
                );
            }
        },
        addClick() {
            this.payslipModal.reset();
            this.payslipModal.show();
        },
        togglePaid(itemIdx) {
            let payslip = this.payslipsTable.items[itemIdx];
            this.payslipsTable.items[itemIdx].paid = !payslip.paid;
            this.$APICall('post', 'payslips/paid/' + payslip.id, {}, () => {}, false);
            if (payslip.paid) {
                this.$verify(this.$t('alerts.sendPayslipEmail'), (result) => {
                    if (result) {
                        this.$APICall('post', 'payslips-send-email/' + payslip.id, {}, (data, success) => {
                            if (success) {
                                this.$alert(this.$t('alerts.pdfSentToSeafarer'));
                            } else {
                                this.$alert(this.$t('alerts.basicError'));
                            }
                        });
                    }
                });
            }
        },
        deleteClick(itemIdx) {
            let vm = this;
            this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
                if (result) {
                    let payslip = vm.payslipsTable.items[itemIdx];
                    vm.payslipsTable.items.splice(itemIdx, 1);
                    vm.$APICall('delete', 'payslips/' + payslip.id, {}, () => {}, false);
                }
            });
        },
        selectHeaders(headers) {
            this.payslipsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.payslipsTable.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'payslips', request, (data, success) => {
                if (success) {
                    vm.payslipsTable.items = data.items;
                    vm.payslipsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.payslipsTable.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'payslips',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/payslips', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.payslipsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.payslips'), href: '/#/payslips', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped>
.seafarer-blocks-holder {
    max-height: 400px;
    overflow: scroll;
    clear: both;
}

.seafarer-block {
    border: 1px solid darkgray;
    margin: 5px;
    padding: 3px 8px 3px 8px;
    cursor: pointer;
}

.seafarer-block:hover {
    background: lightgray;
}

.seafarer-all-block {
    margin: 5px;
    padding: 3px 8px 3px 8px;
    cursor: pointer;
    clear: both;
}
</style>
